import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { MemoryFavouriteAttribute } from 'types/Memory';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { generateURL } from 'utilities/hooks/urlGeneration';

type mutationVariables = Partial<MemoryFavouriteAttribute>;

export function useCreateMemoryFavourite(memoryID: string | undefined) {
  const queryClient = useQueryClient();

  const createMemoryFavorites = (memoryFavourite: mutationVariables) => {
    if (!memoryFavourite.memoryID) {
      Promise.reject('Memory ID Favourite can not be null');
    }

    const body = {
      data: {
        type: 'memoryFavourites',
        attributes: memoryFavourite,
      },
    };

    const url = generateURL(SPARK_RESOURCE_TYPES.MEMORY_FAVOURITES);

    return fetchWrapper<MemoryFavouriteAttribute>({
      url: url,
      method: 'Post',
      body: body,
    });
  };

  return useMutation('createMemoryFavorites', createMemoryFavorites, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['memory', memoryID]);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to create memory favourite: ${error.message}`);
      }
    },
  });
}
